import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { DailyObservationEditComponentComponent } from '../daily-observation-edit-component/daily-observation-edit-component.component';
import { DailyObservationEditPage } from './daily-observation-edit';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { DirectivesModule } from '../../../../directives/directives.module';
import { PipesModule } from '../../../../pipes/pipes.module';

@NgModule({
  declarations: [
    DailyObservationEditComponentComponent,
    DailyObservationEditPage
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyObservationEditPage),
    SharedModule,
    FoundationModule,
    DailyLogPageModule,
    PipesModule,
  ],
  exports: [
    DailyObservationEditComponentComponent
  ]
})
export class DailyObservationEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/daily-observations/daily-observations/daily-observation-edit.module.ts